import { useEffect, useState } from "react";
import styles from './NavBar.module.scss';
import { NavIcon, UpIcon } from "../../../assets/icons";
import { Link } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

export const Navbar = () => {
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroHeight = window.innerHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      setIsSticky(scrollTop > heroHeight);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return(<nav className={`${styles.navbar} ${isSticky ? styles.sticky : styles.absolute}`}>
           <img className={styles.navLogo} alt="Xepp" height={28} src="../../../images/ekedc/logo.png" />
           <NavIcon className={styles.mobileNav} />
           <div className={styles.navLinkContainer}>
              <Link to={`/${ApplicationRoutes.CUSTOMER_SIGNUP}`} className={styles.textLink}><span>Shop Solar Products</span> <UpIcon color="#F9A01B" /></Link>
              <a href="/#" className={styles.navButton}> Get The App</a>
           </div>
        </nav>)
}